module.exports = __webpack_public_path__ + "static/media/wav.60902725.svg";